'use client'
import { useSession } from 'next-auth/react'
import React from 'react'

import { SignOutButton } from '@maestro/commerce-blocks/components/sign-out-button'
import { theme } from '@maestro/local/theme'
import { Button } from '@pearlconvert/ui/components/button'

import '@maestro/commerce-blocks/components/header-topbar/styles/header-topbar.scss'

const HeaderTopbarUserInfo = () => {
  const { data: session } = useSession()
  const user = session?.user
  const {
    header: {
      userInfo: { isEnabledCompany, isEnabledSignOut, isEnabledUserName },
    },
    urls,
  } = theme()

  if (!user?.id) {
    return null
  }

  return (
    <div className="header-topbar-user-info">
      {isEnabledUserName && user.name && (
        <Button
          type="link"
          iconLeft="user"
          url={urls.myAccount}
          className="header-topbar-user-info__name"
        >
          {user.name}
        </Button>
      )}
      {isEnabledCompany && user.company?.name && (
        <span className="header-topbar-user-info__company">
          {user.company.name}
        </span>
      )}
      {isEnabledSignOut && <SignOutButton />}
    </div>
  )
}

export default HeaderTopbarUserInfo
